"use strict"

import React, { useEffect, useState } from "react"

import { isLTPM } from "../../../../../../components/shared_components_registration"

// Where we set distinctions for LTPM/LL versions of the component
const registration = {
  all_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.all" }) : "All"),
  offline_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.offline" }) : "Offline"),
  online_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.online" }) : "Online"),
  filter_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.filter" }) : "Filter Data Type"),
}

export default function FilterObsSourceRadios({ updateGraph, graphKey, index, intl }) {
  const [graphKeyState, setGraphKeyState] = useState({})
  const [value, setValue] = useState("all")

  const handleChange = (graph) => {
    updateGraph && updateGraph(graph)
    setGraphKeyState(graph)
  }

  useEffect(() => {
    setGraphKeyState(graphKey)
    if (graphKey.hideOffline) {
      setValue("online")
    } else if (graphKey.hideOnline) {
      setValue("offline")
    } else {
      setValue("all")
    }
  }, [graphKey])

  return (
    <>
      <div>
        <label>{registration.filter_label(intl)}:</label>
      </div>
      <div
        style={{
          marginBottom: "1px",
          backgroundColor: "var(--lanzalake-grey-light-2)",
          border: "var(--lanzalake-grey) 1px solid",
          padding: "5px",
        }}
        className={"text-center"}
      >
        <div className={"form-check-inline"}>
          <label className={"form-check-label"}>
            <input
              type={"radio"}
              className={"form-check-input"}
              name={`${index}_filterObsType`}
              onChange={() => {
                setValue("all")
                let graph = Object.assign({}, graphKeyState)
                graph.hideOnline && delete graph.hideOnline
                graph.hideOffline && delete graph.hideOffline
                handleChange(graph)
              }}
              checked={value === "all"}
            />
            {registration.all_label(intl)}
          </label>
        </div>
        <div className={"form-check-inline"}>
          <label className={"form-check-label"}>
            <input
              type={"radio"}
              className={"form-check-input"}
              name={`${index}_filterObsType`}
              onChange={() => {
                setValue("offline")
                let graph = Object.assign({}, graphKeyState)
                graph.hideOnline = true
                graph.hideOffline && delete graph.hideOffline
                handleChange(graph)
              }}
              checked={value === "offline"}
            />
            {registration.offline_label(intl)}
          </label>
        </div>
        <div className={"form-check-inline"} style={{ marginRight: "0" }}>
          <label className={"form-check-label"}>
            <input
              type={"radio"}
              className={"form-check-input"}
              name={`${index}_filterObsType`}
              onChange={() => {
                setValue("online")
                let graph = Object.assign({}, graphKeyState)
                graph.hideOffline = true
                graph.hideOnline && delete graph.hideOnline
                handleChange(graph)
              }}
              checked={value === "online"}
            />
            {registration.online_label(intl)}
          </label>
        </div>
      </div>
    </>
  )
}
